import { classes } from './SimpleGalleryModal.st.css';
export const SimpleGalleryModalLogic = _ref => {
  let {
    isMobile,
    biFunctions,
    setIsOpen
  } = _ref;
  const dialogContentWrapperClassName = `${classes.dialogContentWrapper} ${isMobile ? classes.dialogContentWrapperMobile : classes.dialogContentWrapperDesktop}`;
  const dialogContentClassName = `${classes.dialogContent} ${isMobile ? classes.dialogContentMobile : classes.dialogContentDesktop}`;
  const onCloseModal = () => {
    biFunctions.onClose();
    setIsOpen(false);
  };
  return {
    dialogContentWrapperClassName,
    dialogContentClassName,
    onCloseModal
  };
};
//# sourceMappingURL=SimpleGalleryModalLogic.js.map